var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "#4880FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04323 10.8725C6.80458 10.6322 6.41764 10.6322 6.17899 10.8725C5.94034 11.1129 5.94034 11.5025 6.17899 11.7428L9.23455 14.8198C9.4732 15.0601 9.86013 15.0601 10.0988 14.8198L16.821 8.05053C17.0597 7.8102 17.0597 7.42056 16.821 7.18024C16.5824 6.93992 16.1954 6.93992 15.9568 7.18024L9.66667 13.5143L7.04323 10.8725Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckActive);
export default __webpack_public_path__ + "static/media/check_active.19dd577de3b16abf243cdbb4c8a1e7bf.svg";
export { ForwardRef as ReactComponent };